import './homeNavbar.css'

export const Bottom = () => {
    return(
        <>
        
        <div className="bottom">
                <div className="footer_details">
                    <a href="">About</a>
                    <a href="">In the Press</a>
                    <a href="">Resource Center</a>
                    <a href="">Contact Us</a>
                    <a href="">FAQs</a>
                    <a href="">Sitemap</a>
                </div>
                <div className="copyright">
                Copyright Koo 2021 ©
                </div>
        </div>
        
        </>
    )
}